<input type="checkbox"
       id="switcherComponent"
       class="control"
       #checkbox
       [checked]="value"
       (change)="toggle.emit(checkbox.checked)">
<label for="switcherComponent" class="checkbox-toggle"></label>
